<template>
  <v-card flat>
    <v-row style="margin-top:10px">
      <v-col cols="6" style="padding-right:6px;">
        <v-card
          @click="$router.push({name: 'TodoListView'})"
          style="text-align:center"
        >
          <v-container>
            <v-icon color="pink" style="margin-top:16px" size=50>mdi-format-list-bulleted-square</v-icon>
            <p style="margin-top:20px;font-weight:bold;">お買い物リスト<br>を見る</p>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="6" style="padding-left:6px;">
        <v-card style="text-align:center"
          @click="$router.push({name: 'EditTodo'})"
        >
          <v-container>
            <v-icon color="pink" style="margin-top:16px" size=50>mdi-pencil-plus</v-icon>
            <p style="margin-top:20px;font-weight:bold;">お買い物リスト<br>を作成する</p>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" style="padding-top:0px;">
        <v-card style="text-align:left;padding-top:10px;padding-bottom:10px"
          @click="$router.push({name: 'ConfigView'})"
        >
          <v-container>
            <v-icon size=30 style="margin:0 20px">mdi-tools</v-icon>
            <span style="margin-top:20px;">アカウント設定</span>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" style="padding-top:0px;">
        <v-card style="text-align:left;padding-top:10px;padding-bottom:10px"
          @click="$router.push({name: 'LP', query: {from: 'i'}})"
        >
          <v-container>
            <v-icon size=30 style="margin:0 20px">mdi-information-outline</v-icon>
            <span style="margin-top:20px;">本アプリについて</span>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <add-list-btn></add-list-btn>
  </v-card>
</template>
<script>
import AddListBtn from '../components/common/AddListBtn';

// @ is an alias to /src
export default {
  name: 'Home',
  components: {
    AddListBtn
  },
  computed: {
    isLogin () {
      return this.$store.state.user.isLogin
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      // 匿名認証
      if (!this.isLogin) await this.$store.dispatch('user/loginAnonymous')
    }
  }
}
</script>
